export const hr1Sx = { margin: '20px 0 32px 0' };
export const hr2Sx = { margin: '32px 0' };
export const containerSx = { width: '100%' };
export const fieldContainerSx = { marginBottom: '28px' };
